<template>
  <div class="yunxiao parent switch-company"  :class="{'null-company': !current.companyId}">
    <p class="title" v-if="current.companyId">
      当前机构
    </p>
    <div class="company current" v-if="current.companyId">
      <div class="left">
        {{current.companyName}}
        <div class="id-tag">机构ID：{{ current.companyId }}</div>
        <p class="tags-line">
          <span v-for="(tag, idx) of current.parentCompanyTypes" :key="idx">
            {{tags[tag]}}
          </span>
        </p>
      </div>
    </div>
    <p class="title" v-if="others.length">
      其他机构（点击切换为当前机构）
    </p>
    <div class="company" v-for="other of others" :key="other.id">
      <div class="left">
        {{other.companyName}}
        <div class="id-tag">机构ID：{{ other.companyId }}</div>
        <p class="tags-line">
          <span v-for="(tag, idx) of other.parentCompanyTypes" :key="idx">
            {{tags[tag]}}
          </span>
        </p>
      </div>
      <van-button square round size="small" @click="switchCompany(other)">切换</van-button>
    </div>
    <van-empty
      v-if="others.length===0"
      :class="{'null-company': !current.companyId}"
      style="padding-top: 0px;"
      image="https://cdn01.xiaogj.com/uploads/x3/assets/m/img/tips/empty.png"
      image-size="100"
    >
      <template #description>
        <div v-if="!current.companyId" style="text-align:center;">此手机号码暂未关联学员<br>请联系机构老师</div>
        <span v-else>没有更多机构了~</span>
      </template>
    </van-empty>
    <van-button 
      class="switch-login-btn" 
      @click="app.parent.switchUser()"
      type="primary" 
      square round >换手机号登录</van-button>
  </div>
</template>

<script>
export default {
  name: "",
  data () {
    return {
      pageTitle: '选择机构',
      tags: [0, '就读的', '我浏览的', '意向的', '我工作的']
    }
  },
  computed: {
    ...Vuex.mapState(["userInfo"]),
    current () {
      let { companyId, companyList, companyName} = this.userInfo;
      for (let company of companyList) {
        if (company.companyId === companyId) return {...company}
      }
      return {companyId, tags: [], companyName};
    },
    others () {
      let { companyId: defaultCompanyId, companyList} = this.userInfo;
      return (companyList||[]).filter(({companyId})=> companyId!==defaultCompanyId);
    }
  },
  methods: {
    switchCompany ({companyName, companyId}) {
      vant.Dialog.confirm({
        title: "提示",
        message: `是否切换到【${companyName}】`,
      })
        .then(async () => {
          this.showLoading();
          let res = await this.$api.parentUpdateDefaultCompany({companyId});
          if (res.code === 200) {     
            this.$toast.clear();       
            if (res.data) {              
              // console.log('机构切换成功，写入Token', res.data);
              app.ls.set("x3-parent-token", res.data);
              app.http.setHeader("x3-authentication", res.data);
            }
            let query = app.tool.parseQuery();
            query.companyId = companyId;
            let search = app.tool.jsonToQueryStr(query)
            // 跳转到家长端首页
            location.replace(`${location.origin}/app/parent${search}`);
          }
        })
        .catch(()=>{
          console.log('用户取消切换机构了');
        });
    }
  }
}
</script>

<style lang="scss" scoped>
.yunxiao.parent.switch-company{
  padding: calc(var(--gap) *  12) calc(var(--gap) * 16);
  background-color: var(--g1);
  .title{
    margin: calc(var(--gap) * 8) 0;
    font-size:var(--fs-md);
    line-height:var(--lh-md);
    color: var(--g6);
  }
  .company{
    display: flex;
    margin-bottom: calc(var(--gap) * 12);
    padding: calc(var(--gap) * 18) calc(var(--gap) * 16);
    font-size:var(--fs-lg);
    line-height:var(--lh-lg);
    font-weight: 600;
    background-color: var(--white);
    border-radius: var(--radius-sm);
    justify-content: space-between;
    align-items: center;
    &.current{            
      margin-bottom: calc(var(--gap) * 32);
    }
    .id-tag {
      font-weight: normal;
      font-size:var(--fs-md);
      line-height:var(--lh-md);
      color: var(--g6);
    }
    > button {
      background-color: var(--c5);
      border-color: var(--c5);
      color: var(--white);
      font-weight: 400;
      font-size:var(--fs-lg);
      line-height:var(--lh-lg);
    }
    .tags-line{
      margin: calc(var(--gap) * 4) 0 0;
      font-size:var(--fs-sm);
      line-height:var(--lh-sm);
      color: var(--g6);
      font-weight: 400;
      >span{
        display: inline-block;
        margin-right:  calc(var(--gap) * 8);
        padding: calc(var(--gap) * 2) calc(var(--gap) * 4);
        background-color: var(--g2);
        border-radius: calc(var(--radius-base) * 0.5);
      }
    }
  }
  .null-company{
    margin-top: 100px;
  }
  .switch-login-btn{
    display: block;
    margin: 0 auto;
    background-color: var(--c1);
    border-color: var(--c1);
  }
  &.null-company{
    text-align: center;
  }
}
</style>